module.exports = __webpack_public_path__ + "media/images/shark/Naranjo_9201-p-800-29c4833f477122452e379bf8ba4d6007.jpeg";